export default class Fields {
  static get URL_PARAM_FIELDS() {
    return 'fields'
  }

  constructor(criteria) {
    this._fields = {}
    this._criteria = criteria

    if (this._criteria) {
      this.parseCriteria()
    }
  }

  parseCriteria() {
    const paramsFilter = this._criteria.match(
      // eslint-disable-next-line no-useless-escape
      new RegExp(`${Fields.URL_PARAM_FIELDS}=(.+?)\/`, 'i'),
    )

    if (paramsFilter && paramsFilter[1]) {
      const fields = paramsFilter[1].split(',')

      for (const key in fields) {
        if (fields.hasOwnProperty(key)) {
          this._fields[fields[key]] = true
        }
      }
    }
  }

  getFields() {
    return Object.keys(this._fields)
  }

  setFields(fields) {
    if (Array.isArray(fields)) {
      for (const key in fields) {
        if (fields.hasOwnProperty(key)) {
          this._fields[fields[key]] = true
        }
      }
    } else {
      this._fields[fields] = true
    }
  }

  clearFields() {
    this._fields = {}

    return this
  }

  getCriteria() {
    const fields = this.getFields()

    if (fields.length < 1) {
      return ''
    }

    return `${Fields.URL_PARAM_FIELDS}=${fields.join(',')}/`
  }

  getApiCriteria() {
    const fields = this.getFields()

    if (fields.length < 1) {
      return ''
    }

    return `${Fields.URL_PARAM_FIELDS}=${fields.join(',')}`
  }
}
